import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, put, del } from './agent';

const projectTaskCategories =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'project-task-categories', id]).compact().join('/');

    return {
      get: (query = {}, config) => get(url.concat(new QueryString(query).toString(true)), config),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      setDefaultStatus: () => put(url.concat('/is-default')),
      delete: () => del(url),
    };
  };

export default projectTaskCategories;
